/// <reference types="node" />
export const CLIENT_VERSION = "4.26.5";